// Third-party imports
import $ from 'jquery';
import '@chenfengyuan/datepicker';

// Module name
export const MODULE_NAME = 'datepicker';

export let global_vars = {};

export function initialize() {
    let input = $('[data-toggle="datepicker"]');
    let container = input.parent();
    let today = new Date();

    $('[data-toggle="datepicker"]').datepicker({
        autoHide: true,
        autoPick: true,
        container: container,
        language: 'en-GB',
        format: 'dd-mm-yyyy',
        startDate: today,
    });
}
